export default __webpack_public_path__ + "static/media/AmaticSC-Regular.caaf513a.ttf";